// This file configures the initialization of Sentry on the client.
// The added config here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/:customerSlug\",\"regex\":\"^/([^/]+)$\",\"paramNames\":[\"customerSlug\"],\"hasOptionalPrefix\":false},{\"path\":\"/:customerSlug/:departmentSlug\",\"regex\":\"^/([^/]+)/([^/]+)$\",\"paramNames\":[\"customerSlug\",\"departmentSlug\"],\"hasOptionalPrefix\":false}],\"staticRoutes\":[{\"path\":\"/\"}],\"isrRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.3.8";import * as Sentry from "@sentry/nextjs";

Sentry.init({
  dsn: "https://7bd25a7e677fb34a540b073652565ad0@o566339.ingest.us.sentry.io/4510974250319872",
  // Enable logs to be sent to Sentry
  enableLogs: true,

  // Enable sending user PII (Personally Identifiable Information)
  // https://docs.sentry.io/platforms/javascript/guides/nextjs/configuration/options/#sendDefaultPii
  sendDefaultPii: false,

  environment: process.env.SENTRY_ENVIRONMENT
});

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
